import React, { useState, useEffect } from "react";
import crosIcon from '../assets/image/deposite/cros-icon.png';
import { QRCodeCanvas } from 'qrcode.react';
import Cookies from 'js-cookie';
import './USDTForm.css'; // Make sure to import your CSS file
const USDTForm = ({ amount, setAmount, networkLink, setNetworkLink, clearAmount }) => {
  const [walletAddress, setWalletAddress] = useState(""); // State to hold wallet address fetched from backend
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const usdtAmounts = [1, 5, 10, 20, 30, 50, 100, 200, 500];
  const userId = Cookies.get('user_id');
  const baseURLAPI = import.meta.env.VITE_BASE_URL_API; // Define baseURLAPI using environment variable

  // Function to fetch wallet address from the backend
  const fetchWalletAddress = async () => {
    try {
      const response = await fetch(`${baseURLAPI}users_db/getActiveWalletAddress`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched Wallet Address Data:", data);
      if (data.status === 'success' && data.wallet_address) {
        setWalletAddress(data.wallet_address);
      } else {
        throw new Error(data.message || 'Failed to fetch wallet address');
      }
    } catch (error) {
      console.error("Error fetching wallet address:", error);
      setMessage("Error: Unable to fetch wallet address.");
    }
  };

  // Fetch wallet address on component mount
  useEffect(() => {
    fetchWalletAddress();
  }, []);

  const handleDeposit = async () => {
    try {
      console.log("User ID:", userId);
      console.log("Amount:", amount);
      console.log("Network Link:", networkLink);
  
      if (!userId || !amount || amount < 0.1 || !networkLink) {
        setMessage("Please fill in all required fields.");
        return;
      }
  
      setLoading(true);
      setMessage("");
  
      const response = await fetch(`${baseURLAPI}users_db/saveUSDTDeposit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: parseInt(userId, 10),
          amount: parseFloat(amount).toFixed(2),
          network_link: networkLink,
        }),
      });
  
      // Handle empty response or non-JSON response
      const responseText = await response.text();
      let result = {};
      try {
        result = JSON.parse(responseText);
      } catch (error) {
        throw new Error("Received an invalid JSON response from the server.");
      }
  
      if (response.ok) {
        setMessage(result.message);
      } else {
        setMessage(`Error: ${result.message}`);
      }
    } catch (error) {
      setMessage("An error occurred. Please try again later.");
      console.error("Network Error:", error);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="deposit-amount">
      <div className="deposit-amount-heading">
        {/* Heading of the deposit section */}
      </div>
      <div className="usdt-info">
          {walletAddress ? (
          <div className="qr-code-container">
              <QRCodeCanvas value={walletAddress} size={128} />
              <p>{walletAddress}</p>
          </div>
       ) : (
          <p>Fetching Wallet Address...</p>
       )}
      </div>

      <div className="deposit-amount-input">
        <label htmlFor="deposit-amount" style={{ fontSize: '12px' }}>USDT</label>
        <input
          type="text"
          placeholder="Enter amount in USDT"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          onBlur={(e) => {
            const value = parseFloat(e.target.value).toFixed(2);
            setAmount(isNaN(value) ? "" : value);
          }}
          style={{ width: '100%' }}
        />
        <img src={crosIcon} alt="Clear Icon" onClick={clearAmount} style={{ cursor: 'pointer' }} />
      </div>
      <p>Exact amount of USDT Deposited</p>

      <div className="deposit-amount-input">
        <input
          type="text"
          placeholder="Enter network verification link"
          value={networkLink}
          onChange={(e) => setNetworkLink(e.target.value)}
          style={{ width: '100%' }}
        />
        <img src={crosIcon} alt="Clear Icon" onClick={() => setNetworkLink('')} style={{ cursor: 'pointer' }} />
      </div>
      <p>TRC20 Network Verification Link</p>

      <div className="text-center">
        <button
          className={amount === "" || amount < 1 || !networkLink || !walletAddress ? "deposit-btn" : "open-modal-btn"}
          onClick={handleDeposit}
          disabled={loading || amount < 1 || !networkLink || !walletAddress}
        >
          {loading ? "Processing..." : "Deposit"}
        </button>
        {message && <p style={{ color: message.includes("Error") ? 'red' : 'green', marginTop: '5px' }}>{message}</p>}
      </div>
    </div>
  );
};

export default USDTForm;
